import { useEffect, useRef, useState } from 'react'
import { api, upload } from '../api.js'

// Réglage d'un bloc de la page d'accueil. Chaque type n'affiche que ses
// propres champs : on ne demande pas une image à un bloc de texte.
export default function BlocForm({ bloc, onEnregistrer, onSupprimer, onAnnuler }) {
  const [b, setB] = useState({ ...bloc })
  const maj = (champs) => setB({ ...b, ...champs })

  const titres = {
    hero: "Bandeau d'accueil", alerte: "Bandeau d'alerte", search: 'Barre de recherche',
    popular: 'Démarches en avant', categories: 'Toutes les démarches', suivi: 'Suivre ma demande',
    infos: 'Horaires et contact', texte: 'Un texte', image: 'Une image',
    liens: 'Des liens utiles', chiffres: 'Quelques chiffres', news: 'Actualités',
    logo: 'Le logo de la commune',
  }

  return (
    <div className="fenetre" role="dialog" aria-label="Réglages du bloc">
      <div className="fenetre-corps large">
        <h2>{titres[b.type] || b.type}</h2>

        {b.type === 'hero' && (
          <>
            <div className="champ">
              <label htmlFor="b-titre">Titre</label>
              <input id="b-titre" value={b.title || ''} autoFocus
                     onChange={(e) => maj({ title: e.target.value })} />
            </div>
            <div className="champ">
              <label htmlFor="b-lede">Phrase d'accueil</label>
              <textarea id="b-lede" rows={2} value={b.lede || ''}
                        onChange={(e) => maj({ lede: e.target.value })} />
            </div>
          </>
        )}

        {b.type === 'alerte' && (
          <div className="champ">
            <label htmlFor="b-alerte">Message d'alerte</label>
            <textarea id="b-alerte" rows={2} value={b.text || ''} autoFocus
                      onChange={(e) => maj({ text: e.target.value })} />
            <p className="aide">Bandeau très visible en haut du portail. Pensez à le désactiver
              quand la situation est passée.</p>
          </div>
        )}

        {b.type === 'texte' && (
          <>
            <div className="champ">
              <label htmlFor="b-t">Titre</label>
              <input id="b-t" value={b.title || ''} autoFocus
                     onChange={(e) => maj({ title: e.target.value })} />
            </div>
            <div className="champ">
              <label htmlFor="b-txt">Texte</label>
              <textarea id="b-txt" rows={8} value={b.text || ''}
                        onChange={(e) => maj({ text: e.target.value })} />
              <p className="aide">Laissez une ligne vide entre deux paragraphes.</p>
            </div>
          </>
        )}

        {b.type === 'image' && <ChampImage bloc={b} maj={maj} />}

        {b.type === 'logo' && (
          <>
            <p className="aide">Le logo se dépose une seule fois, dans la carte Identité.
              Ce bloc décide seulement de son emplacement dans la page.</p>
            <div className="ligne-champs">
              <div className="champ">
                <label htmlFor="b-lw">Taille</label>
                <select id="b-lw" value={b.width || 'moyenne'}
                        onChange={(e) => maj({ width: e.target.value })}>
                  <option value="petite">Petite</option>
                  <option value="moyenne">Moyenne</option>
                  <option value="grande">Grande</option>
                </select>
              </div>
              <div className="champ">
                <label htmlFor="b-la">Alignement</label>
                <select id="b-la" value={b.align || 'centre'}
                        onChange={(e) => maj({ align: e.target.value })}>
                  <option value="gauche">À gauche</option>
                  <option value="centre">Centré</option>
                  <option value="droite">À droite</option>
                </select>
              </div>
            </div>
          </>
        )}

        {b.type === 'liens' && (
          <>
            <div className="champ">
              <label htmlFor="b-lt">Titre du bloc</label>
              <input id="b-lt" value={b.title || ''} onChange={(e) => maj({ title: e.target.value })} />
            </div>
            <Repetable items={b.items || []} onChange={(items) => maj({ items })}
                       modele={{ label: '', url: 'https://', hint: '' }}
                       ajouter="Ajouter un lien"
                       champs={[['label', 'Intitulé'], ['url', 'Adresse'], ['hint', 'Précision']]} />
          </>
        )}

        {b.type === 'chiffres' && (
          <>
            <div className="champ">
              <label htmlFor="b-ct">Titre du bloc (facultatif)</label>
              <input id="b-ct" value={b.title || ''} onChange={(e) => maj({ title: e.target.value })} />
            </div>
            <Repetable items={b.items || []} onChange={(items) => maj({ items })}
                       modele={{ value: '', label: '' }} ajouter="Ajouter un chiffre"
                       champs={[['value', 'Le chiffre'], ['label', "Ce qu'il désigne"]]} />
          </>
        )}

        {b.type === 'news' && (
          <>
            <div className="champ">
              <label htmlFor="b-nt">Titre du bloc</label>
              <input id="b-nt" value={b.title || ''} onChange={(e) => maj({ title: e.target.value })} />
            </div>
            <Repetable items={b.items || []} onChange={(items) => maj({ items })}
                       modele={{ t: '', d: '' }} ajouter="Ajouter une actualité"
                       champs={[['t', 'Titre'], ['d', 'Détail']]} />
          </>
        )}

        {b.type === 'popular' && (
          <>
            <div className="champ">
              <label htmlFor="b-pt">Titre du bloc</label>
              <input id="b-pt" value={b.title || ''} onChange={(e) => maj({ title: e.target.value })} />
            </div>
            <div className="champ">
              <label htmlFor="b-n">Nombre de démarches mises en avant</label>
              <input id="b-n" type="number" min="2" max="9" value={b.n || 6}
                     onChange={(e) => maj({ n: Number(e.target.value) })} />
              <p className="aide">Ce sont les démarches marquées « mise en avant » dans leurs
                réglages.</p>
            </div>
          </>
        )}

        {b.type === 'categories' && (
          <div className="champ">
            <label htmlFor="b-gt">Titre du bloc</label>
            <input id="b-gt" value={b.title || ''} onChange={(e) => maj({ title: e.target.value })} />
          </div>
        )}

        {['search', 'suivi', 'infos'].includes(b.type) && (
          <p className="aide">Ce bloc n'a rien à régler ici. Vous pouvez seulement l'afficher
            ou le masquer.{b.type === 'infos' && " Les horaires et coordonnées se saisissent dans les paramètres."}</p>
        )}

        <div className="ligne separee">
          {onSupprimer && <button className="btn dgr" onClick={() => onSupprimer(b)}>Retirer</button>}
          <div className="pousse" />
          <button className="btn" onClick={onAnnuler}>Annuler</button>
          <button className="btn pri" onClick={() => onEnregistrer(b)}>Enregistrer</button>
        </div>
      </div>
    </div>
  )
}

function ChampImage({ bloc, maj }) {
  const [bibliotheque, setBibliotheque] = useState([])
  const [erreur, setErreur] = useState('')
  const [envoi, setEnvoi] = useState(false)
  const input = useRef(null)

  const charger = () => { api.media().then(setBibliotheque).catch(() => setBibliotheque([])) }
  useEffect(() => { charger() }, [])

  async function envoyer(fichier) {
    if (!fichier) return
    setEnvoi(true)
    try {
      const r = await upload(fichier)
      maj({ url: r.url })
      setErreur('')
      charger()
    } catch (e) { setErreur(e.message) } finally { setEnvoi(false) }
  }

  return (
    <>
      {erreur && <p className="erreur">{erreur}</p>}

      {bloc.url && (
        <figure className="apercu-image">
          <img src={bloc.url} alt="" />
        </figure>
      )}

      <div className="champ">
        <label htmlFor="b-fichier">Envoyer une image</label>
        <input id="b-fichier" type="file" ref={input} accept="image/*"
               onChange={(e) => envoyer(e.target.files[0])} />
        <p className="aide">JPEG, PNG ou WebP, 5 Mo au maximum. {envoi && 'Envoi en cours…'}</p>
      </div>

      {bibliotheque.length > 0 && (
        <div className="champ">
          <label>Ou reprendre une image déjà envoyée</label>
          <div className="bibliotheque">
            {bibliotheque.map((m) => (
              <button key={m.url} className={bloc.url === m.url ? 'on' : ''}
                      onClick={() => maj({ url: m.url })}>
                <img src={m.url} alt="" loading="lazy" />
              </button>
            ))}
          </div>
        </div>
      )}

      <div className="champ">
        <label htmlFor="b-alt">Description pour les personnes qui ne voient pas l'image</label>
        <input id="b-alt" value={bloc.alt || ''} onChange={(e) => maj({ alt: e.target.value })}
               placeholder="La mairie et son parvis fleuri" />
        <p className="aide">Obligatoire pour l'accessibilité. Décrivez ce que montre l'image.</p>
      </div>
      <div className="champ">
        <label htmlFor="b-cap">Légende affichée sous l'image</label>
        <input id="b-cap" value={bloc.caption || ''}
               onChange={(e) => maj({ caption: e.target.value })} />
      </div>
      <div className="ligne-champs">
        <div className="champ">
          <label htmlFor="b-w">Largeur</label>
          <select id="b-w" value={bloc.width || 'large'}
                  onChange={(e) => maj({ width: e.target.value })}>
            <option value="large">Toute la largeur</option>
            <option value="moyenne">Moyenne</option>
            <option value="petite">Petite</option>
          </select>
        </div>
        <div className="champ">
          <label htmlFor="b-lien">Lien au clic (facultatif)</label>
          <input id="b-lien" value={bloc.link || ''} placeholder="https://"
                 onChange={(e) => maj({ link: e.target.value })} />
        </div>
      </div>
    </>
  )
}

// Petite liste modifiable, pour les liens, les chiffres et les actualités.
function Repetable({ items, onChange, modele, champs, ajouter }) {
  return (
    <>
      {items.map((it, i) => (
        <div className="repetable" key={i}>
          {champs.map(([cle, label]) => (
            <div className="champ" key={cle}>
              <label>{label}</label>
              <input value={it[cle] || ''} onChange={(e) => onChange(
                items.map((x, j) => (j === i ? { ...x, [cle]: e.target.value } : x)))} />
            </div>
          ))}
          <button className="btn sm dgr" onClick={() => onChange(items.filter((_, j) => j !== i))}>
            Retirer
          </button>
        </div>
      ))}
      <button className="btn sm" onClick={() => onChange([...items, { ...modele }])}>{ajouter}</button>
    </>
  )
}
